import { render, staticRenderFns } from "./addChange.vue?vue&type=template&id=12da9770&scoped=true&"
import script from "./addChange.vue?vue&type=script&lang=js&"
export * from "./addChange.vue?vue&type=script&lang=js&"
import style0 from "./addChange.vue?vue&type=style&index=0&id=12da9770&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da9770",
  null
  
)

export default component.exports